import { useEffect } from "react";
import { business } from "@/config/business";

/**
 * Lightweight SEO helper — set <title> & meta tags per halaman.
 * Untuk halaman SEO/landing page baru di masa depan, cukup render:
 *   <Seo title="..." description="..." canonical="/maintenance-ac-kantor" />
 */
function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const Seo = ({
  title = business.seo.title,
  description = business.seo.description,
  keywords = business.seo.keywords,
  canonical = "/",
  ogImage = "",
}) => {
  useEffect(() => {
    const url = `${business.seo.siteUrl}${canonical}`;
    document.title = title;

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    if (ogImage) setMeta("property", "og:image", ogImage);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    setCanonical(url);
  }, [title, description, keywords, canonical, ogImage]);

  return null;
};

export default Seo;
